import { vatRates } from "../config/vat";
import { type IHotelState } from "../features/hotel/hotelInterface";

export const calculateVat = (gross: number, rate: number): number => {
  if (gross <= 0 || rate <= 0) return 0;
  return gross - gross / (1 + rate);
};

export const calculateReservationVat = (
  reservationPriceResponse: {
    ReservationPrice: {
      TotalAmount: { GrossValue: number };
      ProductOrderPrices?: {
        ProductOptions: { OfferToCustomer: boolean };
        TotalAmount: { GrossValue: number };
      }[];
    }[];
  },
  hotelCode: IHotelState["HotelCode"],
) => {
  const rates = vatRates[hotelCode];
  if (!rates) {
    return { roomTaxValue: 0, productTaxValue: 0 };
  }

  let roomGross = 0;
  let productGross = 0;

  reservationPriceResponse.ReservationPrice.forEach((reservation) => {
    const productTotal =
      reservation.ProductOrderPrices?.reduce((acc, pop) => {
        return acc + pop.TotalAmount.GrossValue;
      }, 0) ?? 0;

    roomGross += reservation.TotalAmount.GrossValue - productTotal;

    reservation.ProductOrderPrices?.forEach((pop) => {
      if (pop.ProductOptions.OfferToCustomer) {
        productGross += pop.TotalAmount.GrossValue;
      }
    });
  });

  const roomTaxValue = calculateVat(roomGross, rates.rooms);
  const productTaxValue = calculateVat(productGross, rates.products);

  return { roomTaxValue, productTaxValue };
};
